export default {
  state: {
    splitOrder: null,
    boxes: {},
    splitBoxes: {},
    addressWithPosition: {}
  },
  mutations: {
    setSplitOrder(state, payload) {
      state.splitOrder = payload
    },
    setSplitBox(state, payload) {
      payload.data.forEach(product => {
        if (!state.boxes[payload.position]) {
          state.boxes[payload.position] = {}
        }
        state.boxes[payload.position][product.id] = product
      })
    },
    addAddressToPosition(state, payload) {
      state.addressWithPosition[payload.position] = payload.value
    },
    clearAddressToPosition(state) {
      state.addressWithPosition = {}
    }
  },
  actions: {
    setSplitBox({commit, state}, payload) {
      if (!state.boxes[payload.position]) {
        commit('setSplitBox', payload)
      } else {
        payload.data.forEach(product => {
          state.boxes[payload.position][product.id] = product
        })
      }
    },
    clearSplitBox({state}, payload) {
      delete (state.boxes[payload.position][payload.id])
    },
    clearFullBox({state}, payload) {
      delete (state.boxes[payload.position])
    },
    clearAllBoxes({state}) {
      state.boxes = {}
    },
    returnBoxes({state}) {
      state.boxes = Object.assign({}, state.splitBoxes)
    },
    cloneAllSplitBoxes({state}) {
      state.splitBoxes = state.boxes
    },
    clearAllSplitBoxes({state}) {
      state.splitBoxes = {}
    }
  },
  getters: {
    getSplitOrder(state) {
      return state.splitOrder
    },
    getSplitBox(state) {
      return position => {
        return Object.values(state.boxes[position] || {})
      }
    },
    getSplitBoxByPositionAndId(state) {
      return (position, id) => {
        return state.boxes[position][id]
      }
    },
    getAllListSplit(state) {
      return state.boxes
    },
    getAllSplitBoxes(state) {
      return state.splitBoxes
    },
    getSplitBoxesByPosition(state) {
      return position => {
        return Object.values(state.splitBoxes[position] || {})
      }
    },
    getAddressByPosition(state) {
      return (position) => {
        return state.addressWithPosition[position]
      }
    },
    getAddressAll(state) {
      return state.addressWithPosition
    }
  }
}
